import { Link } from 'react-router-dom';
import { useState } from 'react';


import './BookingForm/PartyForm.css';
import './BookingForm/Feed.css'
import './BookingForm/FloatingLabelInput.css';
import './BookingForm/FloatingLabelSelect.css';
import footer1 from '../../Footer/image/footer1.png'
import footer2 from '../../Footer/image/footer2.png'
import promotion from '../../event-view-all-page/image/promotion.jpg'

import Rectangle from "./image/Rectangle.png"
import feed1 from "./image/feed-1.png"
import feed2 from "./image/feed-2.png"
import feed3 from "./image/feed-3.png"
import feed from "./image/packagebook.jpg"
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";




import PackageLaedFormComp from "./PackageLaedFormComp";
import Accordion from '../../CRP/components/Accordion';
import PartnerTestimonials from '../../PackagePrice/PartnerTestimonials';


const faqs = [
  {
    question: "What happens after I make a group booking?",
    answer: `Once you complete your booking, our team will verify the details and share confirmation along with all event access information via WhatsApp and email within 30 minutes.`,
  },
  {
    question: " How do I receive my booking confirmation?",
    answer: "Your booking confirmation will be sent via WhatsApp and email. Please check your spam folder in case you don’t see it in your inbox."
  },
  {
    question: " Can I make changes to my group size later?",
    answer: "Yes, minor adjustments (up to ±2 people) can be made by contacting our support team at least 24 hours before the event.",
  },
  {
    question: " Will I get a reserved table or entry only?",
    answer: " Your group booking includes priority table allocation (based on availability) and guaranteed entry. Exact table placement is shared before the event.",
  },
  {
    question: "What if I don’t receive a confirmation?",
    answer: "If you haven’t received a confirmation within 30 minutes, please reach out to our support team on WhatsApp",
  },
  {
    question: " Can I add special requests (cake, décor, etc.)?",
    answer: "Absolutely! You can share special requests through WhatsApp after booking, and we’ll coordinate with the venue for custom arrangements.",
  },
  {
    question: "How early should we arrive at the venue?",
    answer: "We recommend arriving 15–20 minutes early to ensure smooth entry and seating for your group.",
  },

];

const testimonials = [
  {
    rating: 5,
    title: "",
    content:
      "Wanted something fun for my 25th birthday and PartyWitty made it so easy. Booked a rooftop lounge with DJ + cake + decor – all sorted in one call!”",
    author: "Aditya Verma, Gurgaon",
  },
  {
    rating: 5,
    title: "",
    content:
      "We booked a bachelorette party package via PartyWitty – got a private section, unlimited drinks, and a host! No back and forth. It was epic.”",
    author: "Sneha R., Delhi",
  },
  {
    rating: 5,
    title: "",
    content:
      "I filled the form, got a call in 30 mins, and booked the venue the same day. The team was super professional and transparent. Zero stress.”",
    author: "Manish T., Faridabad",
  },
  {
    rating: 5,
    title: "",
    content:
      "PartyWitty only sent me verified venues with ratings and clear costs. That saved me so much time. No shady places, no hidden charges.”",
    author: " Pooja Mehra, Saket",
  },
  {
    rating: 5,
    title: "",
    content:
      "I thought party planners were expensive, but PartyWitty helped me host a fun 30th birthday under ₹15k. Super responsive and transparent team.”",
    author: "Siddharth Jain, Rajouri Garden",
  },
  {
    rating: 5,
    title: "",
    content:
      "My plans were super last-minute, but PartyWitty still managed to get me a Saturday night booking with food, drinks, and music. Lifesavers!”",
    author: "Ishita Malhotra, Vasant Kunj",
  },
];


function GroupBooking({ clubId }) {

  const [activeTab, setActiveTab] = useState("package");
  const [imageload, setimageload] = useState(true);

  const [openIndex, setOpenIndex] = useState(null);
  const handleFAQtoggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  return (
    <div className="Package-lead-page-container">
      <div>
        <div className="feed-section-container">
          <div className="feed-section-container-sec-nav">
          </div>
          <div className='feed-section'>
            <div className='feed-section-img feed-image-wrapper'>
              <div className="feed-img-section">
                <>
                  {imageload && <div className='feed-shimmer-box'></div>}

                  <img
                    src={feed}
                    alt="Reserve Party Packages with Food & Drinks Nearby"
                    style={{ display: imageload ? "none" : "block" }} // hide real image until loaded
                    onLoad={() => setimageload(false)}
                    onError={() => setimageload(false)} // also hide shimmer if image fails
                  />
                </>

                {/* <div className='feed-img-overlay'>
                  <h1>Party Planning <span className='feed-img-overlay-span'>Just Got Smarter</span></h1>
                  <div className='feed-img-overlay-list'>
                    <div className='custom-image-list'>
                      <div className='custom-image'><img src={Rectangle} alt="" /> </div>
                      <span>Post your party plan</span>
                    </div>
                    <div className='custom-image-list'>
                      <div className='custom-image'><img src={Rectangle} alt="" /> </div>
                      <span>Let Venues Bid to Host it</span>
                    </div>
                  </div>
                </div> */}

              </div>
            </div>
            <div className='feed-form-section'>
              <div className="tabs-sec-nav">
                <Link to='/package-lead-form'>
                  <div
                    className={`tabs-sec-nav-box ${activeTab === "package" ? "active" : ""}`}
                    onClick={() => setActiveTab("package")}
                  >
                    <h1>Party Package</h1>
                  </div>
                </Link>
                <Link to='/table-book-form'>
                  <div
                    className={`tabs-sec-nav-box ${activeTab === "table" ? "active" : ""}`}
                    onClick={() => setActiveTab("table")}
                  >
                    <h1>Table Reservation</h1>
                  </div>
                </Link>
              </div>
              <h2>Tell Us When Is The Party</h2>
              <>
                <PackageLaedFormComp />
              </>
            </div>
          </div>
          <div>
            <div className='container'>
              <div className='f-feed'>
                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>1000+</h1>
                    <p>Clubs </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed1} alt="" />
                  </div>
                </div>
                <div className='v-line'></div>
                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>5,000 +</h1>
                    <p>F&B Packages </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed2} alt="" />
                  </div>
                </div>
                <div className='v-line'></div>

                <div className='f-feed-line'>
                  <div className='f-feed-text'>
                    <h1>12,000 +</h1>
                    <p>Happy Customers </p>
                  </div>
                  <div className='f-feed-img'>
                    <img src={feed3} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="event-cards-container">
            <div className='event-detail-page-design-bottom-promotional-banner'>
              <div className='event-detail-page-design-bottom-promotional-banner-content'>
                <div className='event-detail-page-design-bottom-promotional-banner-content-heading'>
                  <h1>🎉 Get 500 carrots🥕 instantly → Download the App</h1>
                </div>
                <div className='event-detail-page-design-bottom-promotional-banner-content-images'>
                  <a href="https://apps.apple.com/in/app/partywitty/id6478442502">
                    <img src={footer1} alt="" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                    <img src={footer2} alt="" />
                  </a>
                </div>
              </div>
              <div className='event-detail-page-design-bottom-promotional-banner-image'>
                <img src={promotion} alt="" />
              </div>
            </div>
          </div>

          <div className='package-page-design-bottom-footer-tags-section'>
            <div className="br-container-faqs">
              <div className='event-detail-page-design-content-section-faq-heading' onClick={() => { handleFAQtoggle(1) }}>
                <h2>Frequently asked questions</h2>
                {openIndex === 1 ? <IoIosArrowUp /> : <IoIosArrowDown />}
              </div>

              {openIndex === 1 && (
                <Accordion faqs={faqs} />
              )}
            </div>
          </div>

          <div className='package-page-design-bottom-footer-tags-section'>
            <PartnerTestimonials heading="What Our Customers Say" testimonials={testimonials} />
          </div>


          <div className='package-page-design-bottom-footer-tags-section'>
            <div className='package-page-detail-page-design-bottom-footer-tags'>
              <div className='package-page-detail-page-design-bottom-footer-tags-text'>
                <h1>Plan Your Celebration with the Best Party Packages in Delhi NCR</h1>
                <p>Looking for the perfect venue for your next celebration? PartyWitty helps you discover and book the best party venues, group party venues, and event spaces in Delhi NCR, all in one place. Whether you're hosting a birthday, corporate event, or night party, we make party booking fast, affordable, and hassle-free.
                  <br/>
                  From premium lounges to affordable rooftop cafes, our curated list includes verified party places in Delhi NCR with transparent pricing, instant quotes, and end-to-end support.
                </p>
             
              <h6>Plan Any Type of Event with Ease</h6>
              <p>PartyWitty offers curated packages and venue recommendations for all celebration types:</p>
              <ul>
                <li><strong>Birthday parties</strong> (for kids, teens, adults)</li>
                <li><strong>Bachelor and bachelorette parties</strong></li>
                <li><strong>Kitty parties </strong> and casual get-togethers</li>
                <li><strong>Anniversary celebrations</strong></li>
                <li><strong>Retirement parties</strong> and farewell events</li>
                <li><strong>Group party venues</strong> for teams, friends, or families</li>
                <li><strong>Family gatherings</strong> and festive dinners</li>
                <li><strong>Night parties</strong> at premium venues</li>
              </ul>
              <p>Each package is tailored to your group size, vibe, and budget.</p>
               </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}

export default GroupBooking;

